module.exports = __webpack_public_path__ + "img/banner4.d2c2c115.jpg";